











import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({name: 'DynamicsForm'})
export default class DynamicsForm extends Vue {
  @Prop() public formId!: string;
  @Prop({ default: false }) public preventSubmissionUi!: boolean;

  private API_URL = 'https://public-eur.mkt.dynamics.com/api/v1.0/orgs/fdc1bb54-30cb-41c4-bf08-b0b6bafa4cc1/landingpageforms';
  private CACHED_FORM_URL = 'https://assets-eur.mkt.dynamics.com/fdc1bb54-30cb-41c4-bf08-b0b6bafa4cc1/digitalassets/forms/'.concat(this.formId)
  private SCRIPT_URL = 'https://cxppusa1formui01cdnsa01-endpoint.azureedge.net/eur/FormLoader/FormLoader.bundle.js';

  beforeMount() {
    if (!this.formId) return;
    if (this.checkForExistingScript()) return;

    const script = document.createElement('script');
    script.src = this.SCRIPT_URL;
    document.body.appendChild(script);
  }

  checkForExistingScript() {
    const script = document.querySelector(`script[src="${this.SCRIPT_URL}"]`);
    if (script) {
      console.debug('Dynamics script is already loaded')
      return true;
    }
    return false;
  }
}
